export default __webpack_public_path__ + "static/media/Amanda_Dickens_AHV_In_Moms_We_Trust.6f487166.jpg";